var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"refresh-btn"},'button',_vm.attrs,false),_vm.$listeners),[_c('base-icon',{attrs:{"name":"ic-refresh"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }